import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { flushSync } from 'react-dom';
import './index.css';
import App from './App';

const rootElement = document.getElementById('root');
const app = (
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

const normalizeRoute = (path) => path === '/' ? '/' : `${path.replace(/\/+$/, '')}/`;
const prerenderedRoute = rootElement.dataset.prerenderRoute;
const routeMatches = prerenderedRoute
    && normalizeRoute(prerenderedRoute) === normalizeRoute(window.location.pathname);

if (window.__TIPLY_PRERENDER__) {
    window.__TIPLY_RENDER_STATIC_HTML__ = async () => {
        const { renderToString } = await import('react-dom/server');
        return renderToString(app);
    };
}

if (routeMatches) {
    hydrateRoot(rootElement, app);
} else {
    if (rootElement.hasChildNodes()) rootElement.replaceChildren();
    delete rootElement.dataset.prerenderRoute;
    const root = createRoot(rootElement);
    flushSync(() => root.render(app));
}

// ✅ Remove the preload overlay after React mounts
if (window.__tiplyAppMounted) {
    window.__tiplyAppMounted();
}
